import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import sideImage1 from '../assets/sideview1.jpg'; // Replace with your actual image file
import mainImage from '../assets/mainview.PNG';   // Replace with your actual image file
import sideImage2 from '../assets/sideview2.jpg'; // Replace with your actual image file

// The component is now simplified to hold the new structure.

const ClubInfo = () => {
  const { t } = useTranslation();

  return (
    <section id="about-us" className="club-info-section">
      <div className="club-info-content">
        <div className="club-text-content">
          <h2 className="club-headline">
            {t('clubInfo.headline')}
          </h2>
          <p className="club-body">
            <Trans i18nKey="clubInfo.body1">
              Our club features <strong>five high-quality courts</strong> (with three more on the way), a dedicated <strong>social area</strong>, refreshing <strong>drinks</strong>, and — something every player will appreciate — <strong>unlimited parking</strong>.
            </Trans>
          <br />
          <br />
            {t('clubInfo.body2')}
          </p>
        </div>
        <div className="club-image-gallery">
          {/* 
            ==================================================================
            <<< PASTE YOUR IMAGE URLS HERE >>>
            
            Replace the placeholder URLs below with links to your own images.
            ==================================================================
          */}
          <img 
            src={sideImage1}
            alt={t('clubInfo.altSide1')}
            className="gallery-image side-image"
          />
          <img 
            src={mainImage}
            alt={t('clubInfo.altMain')}
            className="gallery-image main-image"
          />
          <img 
            src={sideImage2}
            alt={t('clubInfo.altSide2')}
            className="gallery-image side-image"
          />
        </div>
      </div>
    </section>
  );
};

export default ClubInfo;